import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

import { Cell } from '../Cell';
import type {
  CellValue,
} from '../Cell';
import { Row } from '../Row';

import { Hint } from '../Hint';

export const StyledWrapper = styled.div<{
  isEdit: boolean;
}>(({
  isEdit,

  theme: {
    indents,
  },
}) => ({
  '& + &': {
    marginTop: isEdit ? indents.INDENT_6 : indents.INDENT_5,
  },
}));

export const StyledTitle = styled.div(({
  theme: {
    fonts,
  },
}) => ({
  ...fonts.H4,
}));

export type SectionProps = {
  /**
   * Заголовок секции
   */
  title?: string;
  /**
   * Количество колонок заголовка
   */
  titleColsXs?: CellValue;
  /**
   * Количество колонок контента
   */
  contentColsXs?: CellValue;
  /**
   * Подсказка, выводящаяся у заголовка поля
   */
  hint?: ReactNode;
  /**
   * Используется ли внутри формы редактирования
   */
  isEdit?: boolean;
  /**
   * Контент
   */
  children?: ReactNode;
};

export function Section({
  title = undefined,
  titleColsXs = 3,
  contentColsXs = 8,
  hint = undefined,
  isEdit = false,
  children = undefined,
}: SectionProps): ReactElement {
  return (
    <StyledWrapper
      isEdit={isEdit}
    >
      <Row>
        <Cell xs={titleColsXs}>
          <StyledTitle>
            { title }
            {' '}
            {
              hint && (
                <Hint
                  tooltip={hint}
                />
              )
            }
          </StyledTitle>
        </Cell>

        <Cell xs={contentColsXs}>
          { children }
        </Cell>
      </Row>
    </StyledWrapper>
  );
}
